import { IT, MCT } from "../../../consts";
import appConfig from "../../../appConfig";
import ExpandableAlert from "../../../apps/admin/component/ExpandableAlert";
import React from "react";

const showIfEverGreen = [
  {
    field: "eventsToShowOption",
    value: "evergreen",
    defaultValue: "evergreen",
  },
];

const showIfStatic = [
  {
    field: "eventsToShowOption",
    value: "defaults",
    defaultValue: "evergreen",
  },
];

export const definitions = {
  title: "Mailchimp",
  icon: "padding",
  groups: [
    {
      label: "Events control",
      message: (
        <ExpandableAlert
          errorLevel={"info"}
          header={"Difference between static and evergreen options?\n"}
          body={
            <span>
              Both options start with your calendar defaults and can be modified
              further.
              <br />
              <strong>Static (one-time)</strong> → same newsletter each time.
              Example: one-time or non-repeating events or event series such as
              Easter program.
              <br />
              <strong>Evergreen (recurring)</strong> → updated newsletter each
              time. Example: what's happening this week.
            </span>
          }
        ></ExpandableAlert>
      ),
      options: [
        {
          title: "Method to show events",
          templates: [MCT.list, MCT.compact, MCT.text],
          name: "eventsToShow",
          defaultValue: "evergreen",
          tooltip: null,

          control: {
            kind: "radio",
            options: {
              radioOptions: [
                {
                  title: "Static (one-time)",
                  value: "defaults",
                  template: [MCT.list, MCT.compact, MCT.text],
                },
                {
                  title: "Evergreen (recurring)",
                  value: "evergreen",
                  template: [MCT.list, MCT.compact, MCT.text],
                },
              ],
            },
          },
        },
        {
          title: "Show events starting from",
          templates: [MCT.list, MCT.compact, MCT.text],
          name: "startDate",
          defaultValue: "today",
          tooltip: null,
          show: showIfEverGreen,
          control: {
            kind: "dropdown",
            options: {
              dropdownOptions: [
                { label: "Today", value: "today" },
                { label: "next Monday", value: "mon" },
                { label: "next Tuesday", value: "tue" },
                { label: "next Wednesday", value: "wed" },
                { label: "next Thursday", value: "thu" },
                { label: "next Friday", value: "fri" },
                { label: "next Saturday", value: "sat" },
                { label: "next Sunday", value: "sun" },
                {
                  label: "first day of the next month",
                  value: "first_day_of_the_next_month",
                },
              ],
            },
          },
        },
        {
          title: "Limit events by number of days",
          templates: [MCT.list, MCT.compact, MCT.text],
          name: "daysLimit",
          defaultValue: "daysLimit",
          tooltip: null,
          show: showIfStatic,
          control: {
            kind: "radio",
            options: {
              radioOptions: [
                {
                  title: "Use calendar defaults",
                  value: "all",
                  template: [MCT.list, MCT.compact, MCT.text],
                },

                {
                  title: "Show events for the next",
                  value: "daysLimit",
                  template: [MCT.list, MCT.compact, MCT.text],
                  input: {
                    defaultValue: 31,
                    postLabel: "days",
                    type: "number",
                    min: 1,
                    max: 31,
                  },
                },
                {
                  title: "Show events within this time range",
                  value: "date_range",
                  template: [MCT.list, MCT.compact, MCT.text],
                  input: {
                    type: "daterange",
                    defaultValue: "",
                  },
                },
              ],
            },
          },
        },
        {
          title: "Limit events by number of days",
          templates: [MCT.list, MCT.compact, MCT.text],
          name: "daysLimit",
          defaultValue: "daysLimit",
          tooltip: null,
          show: showIfEverGreen,
          control: {
            kind: "radio",
            options: {
              radioOptions: [
                {
                  title: "Use calendar defaults",
                  value: "all",
                  template: [MCT.list, MCT.compact, MCT.text],
                },

                {
                  title: "Show events for the next",
                  value: "daysLimit",
                  template: [MCT.list, MCT.compact, MCT.text],
                  input: {
                    defaultValue: 31,
                    postLabel: "days",
                    type: "number",
                    min: 1,
                    max: 31,
                  },
                },
                {
                  title: "Show the next",
                  value: "eventsLimit",
                  template: [MCT.list, MCT.compact],
                  input: {
                    defaultValue: 31,
                    postLabel: "events",
                    type: "number",
                    min: 1,
                    max: 31,
                  },
                },
              ],
            },
          },
        },
        {
          title: "Limit events",
          templates: [MCT.list, MCT.compact, MCT.text],
          name: "eventsLimit",
          defaultValue: "all",
          tooltip: null,
          show: [
            {
              field: "daysLimitOption",
              value: "all",
              defaultValue: "daysLimit",
            },
            {
              field: "daysLimitOption",
              value: "daysLimit",
              defaultValue: "daysLimit",
              or: true,
            },
          ],
          control: {
            kind: "radio",
            options: {
              radioOptions: [
                {
                  title: "Use calendar defaults",
                  value: "all",
                  template: [MCT.list, MCT.compact, MCT.text],
                },
                {
                  title: "Show only",
                  value: "upcoming-limit",
                  template: [MCT.list, MCT.compact, MCT.text],
                  input: {
                    defaultValue: 3,
                    postLabel: "events",
                    type: "number",
                    min: 1,
                    max: 31,
                  },
                },
              ],
            },
          },
        },
      ],
    },
    {
      label: "Display information",
      options: [
        {
          title: "Show event title",
          templates: [MCT.list],
          name: "showTitle",
          defaultValue: 1,
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show date",
          templates: [MCT.list],
          name: "showDate",
          defaultValue: 1,
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show location",
          templates: [MCT.list, MCT.compact, MCT.text],
          name: "showLocation",
          defaultValue: 1,
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show description",
          templates: [MCT.list, MCT.compact],
          name: "showDescription",
          defaultValue: 1,
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Limit description length",
          templates: [MCT.list, MCT.compact],
          name: "limitDescription",
          defaultValue: 1,
          tooltip: null,
          show: [
            {
              field: "showDescription",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show Read more",
          templates: [MCT.list, MCT.compact],
          name: "showReadMore",
          defaultValue: 1,
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show Add to Calendar",
          templates: [MCT.list, MCT.compact, MCT.text],
          name: "showAddToCalMore",
          defaultValue: 1,
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
        {
          title: "Show image",
          templates: [MCT.list, MCT.compact],
          name: "showImage",
          defaultValue: 1,
          tooltip: null,
          control: {
            kind: "checkbox",
            options: {},
          },
        },
      ],
    },
    {
      label: "Template",
      options: [
        {
          title: "Background",
          templates: [MCT.list, MCT.compact, MCT.text],
          name: "bgColor",
          defaultValue: "#ffffff",
          style: [
            {
              selector: ["._____NONE"],
              property: "background-color",
            },
          ],
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Event title",
          templates: [MCT.list, MCT.compact],
          name: "titleColor",
          defaultValue: "#0068A5",
          style: [
            {
              selector: ["._____NONE"],
              property: "color",
            },
          ],
          show: [
            {
              field: "showTitle",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "color",
          },
        },
        {
          title: "Event title",
          templates: [MCT.text],
          name: "titleColor",
          defaultValue: "#832f87",
          style: [
            {
              selector: ["._____NONE"],
              property: "color",
            },
          ],
          show: [
            {
              field: "showTitle",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "color",
          },
        },

        {
          title: "Date",
          templates: [MCT.list],
          name: "dateColor",
          defaultValue: "#000",
          style: [
            {
              selector: ["._____NONE"],
              property: "color",
            },
          ],
          show: [
            {
              field: "showDate",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "color",
          },
        },
        {
          title: "Location",
          templates: [MCT.list],
          name: "locationColor",
          defaultValue: "#000",
          style: [
            {
              selector: ["._____NONE"],
              property: "color",
            },
          ],
          show: [
            {
              field: "showLocation",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "color",
          },
        },
        {
          title: "Date and location",
          templates: [MCT.compact, MCT.text],
          name: "dateLocationColor",
          defaultValue: "#000",
          style: [
            {
              selector: ["._____NONE"],
              property: "color",
            },
          ],
          show: [
            {
              field: "showDate",
              value: 1,
              defaultValue: 1,
            },
            {
              field: "showLocation",
              value: 1,
              defaultValue: 1,
              or: true,
            },
          ],
          control: {
            kind: "color",
          },
        },
        {
          title: "Background",
          templates: [MCT.text],
          name: "addToCalColor",
          defaultValue: "#832f87",
          style: [
            {
              selector: ["._____NONE"],
              property: "color",
            },
          ],
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Description",
          templates: [MCT.list, MCT.compact],
          name: "descriptionColor",
          defaultValue: "#000",
          style: [
            {
              selector: ["._____NONE"],
              property: "color",
            },
          ],
          show: [
            {
              field: "showDescription",
              value: 1,
              defaultValue: 1,
            },
          ],
          control: {
            kind: "color",
          },
        },
        {
          title: "Read more link",
          templates: [MCT.list, MCT.compact],
          name: "readMoreColor",
          defaultValue: "#0068A5",
          style: [
            {
              selector: ["._____NONE"],
              property: "color",
            },
          ],
          control: {
            kind: "color",
          },
          show: [
            {
              field: "showReadMore",
              value: 1,
              defaultValue: 1,
            },
          ],
        },
        {
          title: "Divider",
          templates: [MCT.list, MCT.compact],
          name: "dividerColor",
          defaultValue: "#bbb",
          style: [
            {
              selector: ["._____NONE"],
              property: "background-color",
            },
          ],
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: true,
            },
          },
        },
      ],
    },
    {
      label: "Add to Calendar button",
      options: [
        {
          title: "Background",
          templates: [MCT.list, MCT.compact],
          name: "addToCalBgColor",
          defaultValue: "#3aaee0",
          style: [
            {
              selector: ["._____NONE"],
              property: "background-color",
            },
          ],
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Background on hover",
          templates: [MCT.list, MCT.compact],
          name: "addToCalBgColorHover",
          defaultValue: "#3aaee0",
          style: [
            {
              selector: ["._____NONE"],
              property: "background-color",
            },
          ],
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Label",
          templates: [MCT.list, MCT.compact],
          name: "addToCalColor",
          defaultValue: "#fff",
          style: [
            {
              selector: ["._____NONE"],
              property: "color",
            },
          ],
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
        {
          title: "Label on hover",
          templates: [MCT.list, MCT.compact],
          name: "addToCalColorHover",
          defaultValue: "#fff",
          style: [
            {
              selector: ["._____NONE"],
              property: "color",
            },
          ],
          control: {
            kind: "color",
            options: {
              showInherit: false,
              showCustomValue: false,
              showTransparentOption: false,
            },
          },
        },
      ],
    },
  ],
};
